import React, { Component } from "react";
import { Form, Button, Image } from "react-bootstrap";
import { Link } from "react-router-dom";
import { get } from "lodash";
import DisplayByPermission from "../../component/DisplayByPermission";
import { dateFormat, isValidArray, getLocalstorage } from "../../helper";
import { PreNode, ReadMore, RedirectUser } from "../reusableComponent";
import ProjectAddDecisionModal from "./ProjectAddDecisionModal";
import attachmentIcon from "../../assets/attachment-icon.svg";

import redEditImg from "../../assets/ci_red_edit.svg";
import whiteEditImg from "../../assets/ci_white_edit.svg";

const DRAFT = "DRAFT";
const REJECTED = "Rejected";
const UNDER_CENTRAL_PMG = "under central pmg";

class AgendaProjectDecision extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayProjectPopUp: false
      //viewMoreStatus: false,
      //issueAction: false
    };
  }

  onToggleModal = () => {
    this.setState(prevState => ({
      displayProjectPopUp: !prevState["displayProjectPopUp"]
      //viewMoreStatus: false
    }));
  };
  //   handleViewMore = () => {
  //     this.onToggleModal();
  //     this.setState({
  //       viewMoreStatus: true
  //     });
  //   };

  render() {
    const {
      issue,
      agendaData,
      permission,
      project,
      handleUpdateStatus
    } = this.props;
    const { displayProjectPopUp } = this.state;

    const showMeetingData = get(project, "projectDecisions", []).find(value => {
      return agendaData.id === value.meetingId;
    });

    // if (showMeetingData) {
    //   showMeetingData.fileDTOList = [
    //     {
    //       id: 15124,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15123,
    //       title: "test",
    //       mineType: null,
    //       name: "test.PNG",
    //       s3Url: "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15122,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //     {
    //       id: 15121,
    //       title: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
    //       mineType: null,
    //       name: "Lorem Ipsum is simply dummy text of the printing and typesetting industry.PNG",
    //       s3Url:
    //         "https://pmiic-non-prod-assets.s3.ap-south-1.amazonaws.com/1717138615594-Capture1.PNG",
    //       s3FileName: "1717138615594-Capture1.PNG"
    //     },
    //   ]
    // }

    const { groupCategory } = getLocalstorage("user");
    const userInfo = getLocalstorage("user");
    const isUserPMG = get(userInfo, "groupCategory") === "PMG";
    const meetingStatus = get(agendaData, "meetingStatus", null);
    const superAdminEditable = get(agendaData, "superAdminEditable", false);

    return (
      <>
        <div class="add-decision-wrapper project-add-decision-wrapper">
          <div class="agenda-decision-btn-wrapper">
            {get(project, "projectDecisions", []).length && showMeetingData ? (
              <>
                <div className="mom-desc mom-desc-project">
                  <div className="d-flex flex-row justify-content-between align-items-center">
                    <h4>Minutes of Meeting</h4>
                  </div>
                  <div className="mom-data">
                    <p className="m-0">
                      <PreNode classes="pre-node-decision">
                        <ReadMore
                          clamp={5}
                          content={get(showMeetingData, "projectmom", "NA")}
                        />
                      </PreNode>
                    </p>
                  </div>
                  {isValidArray(get(showMeetingData, "fileDTOList")) ? (
                    <div className="momDesc momDesc-project">
                      <div className="agenda-decision-container">
                        <div className="attachmentsDetails">
                          <img
                            src={attachmentIcon}
                            alt="attachment icon"
                            className="mr-1 attachmentIcon"
                          />
                          <div className="meeting-attachments">
                            {get(showMeetingData, "fileDTOList", []).map(
                              (val, index) => {
                                console.log("val", val);
                                const extension = val.name.substr(
                                  val.name.lastIndexOf(".") + 1,
                                  val.name.length
                                );
                                return (
                                  <>
                                    <div className="momdesc_attachment">
                                      <a
                                        href={val.s3Url}
                                        rel="noopener noreferrer"
                                        target="_blank"
                                      >
                                        {/* {val.title} */}
                                        {val.title != null
                                          ? val.title.length > 20
                                            ? val.title.substring(0, 20) + "..."
                                            : val.title
                                          : val.name.length > 20
                                          ? val.name.substring(0, 20) + "..."
                                          : val.name}

                                        {index <
                                        get(showMeetingData, "fileDTOList", [])
                                          .length -
                                          1 ? (
                                          <>
                                            {", "}
                                            <span style={{ whiteSpace: "pre" }}>
                                              {"\u00A0"}
                                            </span>
                                          </>
                                        ) : (
                                          <> </>
                                        )}
                                        {/* &nbsp;{"  "}&nbsp; */}
                                      </a>
                                      <div class="attachment-added">
                                        <div class="project-download-icons">
                                          <div class="download-icons-pdf">
                                            {extension}
                                          </div>
                                          <a
                                            target="_blank"
                                            href={val.s3Url}
                                            download="Screenshot 2023-08-10 173004.png"
                                            rel="noopener noreferrer"
                                          >
                                            {val.title != null
                                              ? val.title
                                              : val.name}
                                          </a>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              }
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                {meetingStatus === "SCHEDULED" ||
                (meetingStatus === "CONCLUDED" && superAdminEditable) ? (
                  // <Button
                  //   className="edit-decision-button-agenda shadow-none"
                  //   onClick={this.onToggleModal}
                  // >
                  //   EDIT DECISION
                  // </Button>
                  <Button
                    className="project-add-decision-btn"
                    onClick={this.onToggleModal}
                  >
                    <img src={redEditImg} className="projecteditbtnImg" />
                    <img
                      src={whiteEditImg}
                      className="projecteditbtnImgOnHover"
                    />
                    EDIT DECISION
                  </Button>
                ) : null}
                <div
                  className={
                    get(agendaData, "meetingStatus", "NA") === "SCHEDULED"
                      ? "agenda-decision-container decision-submitted-by scheduled"
                      : "agenda-decision-container decision-submitted-by not-scheduled"
                  }
                >
                  <div className="show-date-status d-flex ml-auto">
                    {get(showMeetingData, "decisionCreatedByName", "NA") ==
                    null ? (
                      <></>
                    ) : (
                      <>
                        <div className="decision-submission-date">
                          <span class="issue-created-by verified-user" />
                          <span class="first-pp-name">
                            <span class="issue-creator-name  text-left">
                              <RedirectUser
                                title={get(
                                  showMeetingData,
                                  "decisionCreatedByName",
                                  "NA"
                                )}
                                id={
                                  isUserPMG == false
                                    ? get(
                                        showMeetingData,
                                        "decisionCreatedById",
                                        "NA"
                                      )
                                    : get(
                                        showMeetingData,
                                        "decisionCreatedById",
                                        "NA"
                                      )
                                }
                              />
                            </span>
                          </span>
                        </div>
                      </>
                    )}
                  </div>
                  <div
                    className={
                      get(showMeetingData, "decisionCreatedByName", "NA") ==
                      null
                        ? null
                        : "decision-submission-date issue-id-wrapper decision-left-border"
                    }
                  >
                    Decision Submitted on :{" "}
                    {dateFormat(get(showMeetingData, "createdDate", null))}
                  </div>
                </div>
              </>
            ) : // get(agendaData, "meetingStatus", null) === "SCHEDULED" && (
            //   <Button
            //     className="add-decision-button-agenda shadow-none"
            //     onClick={this.onToggleModal}
            //   >
            //     ADD DECISION
            //   </Button>
            // )
            null}
          </div>
        </div>

        <DisplayByPermission display={displayProjectPopUp}>
          <ProjectAddDecisionModal
            displayProjectPopUp={displayProjectPopUp}
            agendaDetails={agendaData}
            project={project}
            meetingData={showMeetingData}
            handleClose={this.onToggleModal}
            handleUpdateStatus={handleUpdateStatus}
            title={!showMeetingData ? "Add" : "Edit"}
          />
        </DisplayByPermission>
      </>
    );
  }
}
export default AgendaProjectDecision;
